import Vue from 'vue'
import Router from 'vue-router'

/**
 * 重写路由的push方法;解决重复点击同一个路由报错问题
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
};

Vue.use(Router);

const router = new Router({
  // 跳转页面置顶
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  // mode: 'history',
  routes: [
    {
        // 首页
        path: '/',
        name: '',
        component: () => import('@/views/layout/index.vue'),
        redirect: '/index',
        children:[
            {
                path: '/index',
                name: 'index',
                component: () => import('@/views/index/index.vue')
            },
             {
              path: '/about_us',
              name: 'About_us',
              component: () => import('@/views/about_us/index.vue'),
            },
            {
              path: '/contact_us',
              name: 'contact_us',
              component: () => import('@/views/contact_us/contact_us.vue'),
            },
            {
              path: '/blogs',
              name: 'blogs',
              component: () => import('@/views/blogs/index.vue'),
            },
        ],
    },
    // 404页面
    {
      path: '/:pathMatch(.*)*',
      redirect: '/index'
      // 或者 component: () => import('@/views/404.vue')
    }
  ]
});
export default router
